module.exports = {"id":"159145","name":"Bafétimbi Gomis","rating":"80","photo":"./data/images/photos/0/159145.png","club":{"name":"Galatasaray","logo":"./data/images/clubs/Galatasaray.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BafetimbiGomis0.json
// module id = 520
// module chunks = 0